import { get } from 'lodash';
import { resolve } from 'redux-optimist-promise';
import { getDepartureCities } from 'Utils/faceting/facetingUtils';
import createReducer from 'Store/utils/createReducer';
import { FACETING_SEARCH_REQUEST } from 'Store/faceting/constants';
const initialState = {
  departureCities: [] as SearchFacetCategory[],
};
type FacetingTripInformationState = typeof initialState;

const facetingTripInformation = createReducer<FacetingTripInformationState>(initialState, {
  [resolve(FACETING_SEARCH_REQUEST)](
    _state: FacetingTripInformationState,
    action: FacetingSearchRequestResolvedAction,
  ): FacetingTripInformationState {
    return {
      departureCities: getDepartureCities(
        get(action, 'payload.catalogs', []) as SearchFacetCategory[],
      ) as unknown as SearchFacetCategory[],
    };
  },
});
export default facetingTripInformation;
